import type { Product } from "../../shared/types";
import { normalizeLocalizedName } from "../../shared/validation";

const normalizeSearch = (value: string) => normalizeLocalizedName(value).replace(/ه/g, "ە");

function distanceAtMostOne(left: string, right: string) {
  if (Math.abs(left.length - right.length) > 1 || Math.min(left.length, right.length) < 4) return false;
  let i = 0; let j = 0; let edits = 0;
  while (i < left.length && j < right.length) {
    if (left[i] === right[j]) { i++; j++; continue; }
    if (++edits > 1) return false;
    if (left.length > right.length) i++;
    else if (right.length > left.length) j++;
    else { i++; j++; }
  }
  return edits + Number(i < left.length || j < right.length) <= 1;
}

function titleScore(title: string, query: string) {
  if (title === query) return 1000;
  if (title.startsWith(query)) return 800;
  if (title.includes(query)) return 650;
  const titleWords = title.split(" ").filter(Boolean);
  const queryWords = query.split(" ").filter(Boolean);
  let score = 0;
  for (const word of queryWords) {
    const exact = titleWords.find((candidate) => candidate === word);
    const prefix = titleWords.find((candidate) => candidate.startsWith(word) || word.startsWith(candidate));
    const fuzzy = titleWords.find((candidate) => distanceAtMostOne(candidate, word));
    if (exact) score += 150;
    else if (prefix && Math.min(prefix.length, word.length) >= 3) score += 110;
    else if (fuzzy) score += 75;
    else return 0;
  }
  return score;
}

export function rankProducts(products: Product[], rawQuery: string, categoryId = "", subcategoryId = "") {
  const query = normalizeSearch(rawQuery);
  return products.map((product, index) => {
    const score = query ? Math.max(titleScore(normalizeSearch(product.title_ku), query), titleScore(normalizeSearch(product.title_ar), query)) : 1;
    const preferred = subcategoryId && product.subcategory_id === subcategoryId ? 2 : categoryId && product.category_id === categoryId ? 1 : 0;
    return { product, index, score, preferred };
  }).filter((item) => item.score > 0)
    .sort((a, b) => b.preferred - a.preferred || b.score - a.score || a.index - b.index)
    .map((item) => item.product);
}
